import React from 'react';
import { usePlayer } from '../contexts/PlayerContext';

interface FavoriteButtonProps {
  postId: string;
  className?: string;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ postId, className = '' }) => {
  const { isFavorite, toggleFavorite } = usePlayer();
  const active = isFavorite(postId);

  return (
    <button
      type="button"
      className={`player-favorite-btn${active ? ' player-favorite-btn-active' : ''} ${className}`.trim()}
      onClick={() => toggleFavorite(postId)}
      aria-label={active ? 'Remove from favourites' : 'Add to favourites'}
      title={active ? 'Remove from favourites' : 'Add to favourites'}
    >
      <svg viewBox="0 0 24 24" aria-hidden>
        <path
          fill={active ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth="2"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
      </svg>
    </button>
  );
};

export default FavoriteButton;
